"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IcatuPensionTransactionType = void 0;
var IcatuPensionTransactionType;
(function (IcatuPensionTransactionType) {
    // APL – Contribuição – Aplicação
    IcatuPensionTransactionType["Application"] = "APL";
    // RES - Resgate
    IcatuPensionTransactionType["Withdraw"] = "RES";
    // TEE – Transferência Externa de Entrada
    IcatuPensionTransactionType["ExternalTransferInput"] = "TEE";
    // TES – Transferência Externa de Saída
    IcatuPensionTransactionType["ExternalTransferOutput"] = "TES";
    // TIE – Mudança de fundo – Entrada (Transferência Interna de Entrada quando os fundos origem e destino são diferentes)
    IcatuPensionTransactionType["InternalTransferInput"] = "TIE";
    // TIS – Mudança de fundo – Saída (Transferência Interna de Saída quando os fundos origem e destino são diferentes)
    IcatuPensionTransactionType["InternalTransferOutput"] = "TIS";
    // URE – Unificação de reserva de Entrada (Transferência Interna de Entrada quando os fundos origem e destino são iguais)
    IcatuPensionTransactionType["MergeBalanceInput"] = "URE";
    // URS – Unificação de reserva de Saída (Transferência Interna de Saída quando os fundos origem e destino são iguais)
    IcatuPensionTransactionType["MergeBalanceOutput"] = "URS";
})(IcatuPensionTransactionType = exports.IcatuPensionTransactionType || (exports.IcatuPensionTransactionType = {}));
//# sourceMappingURL=IcatuPensionTransactionType.js.map